import { Link } from "react-router-dom";
import { trackSeoPageEvent, SEO_ANALYTICS_EVENTS } from "../../../constants/seoAnalyticsConstants";
import { buildSearchResultsHref } from "../../../services/seoPageService";
import { updateAttributionContext } from "../../../utils/campaignAttribution";
import SeoBreadcrumbs from "./SeoBreadcrumbs";
import SeoTrustStrip from "./SeoTrustStrip";
import SeoInventoryModule from "./SeoInventoryModule";
import SeoBuyerGuidance from "./SeoBuyerGuidance";
import SeoFaqSection from "./SeoFaqSection";
import SeoInternalLinks from "./SeoInternalLinks";
import SeoDealerSection from "./SeoDealerSection";
import SeoDealerCityModule from "./SeoDealerCityModule";
import { SEO_PAGE_TYPES } from "../../../constants/seoPageConstants";

export default function SeoLandingRenderer({
  config,
  metadata,
  breadcrumbs = [],
  internalLinks = [],
  faqItems = [],
  listings = [],
  featuredListings = [],
  inventoryTotal = 0,
  loading = false,
  inventoryError = null,
  dealers = [],
  dealersLoading = false,
}) {
  const searchHref = buildSearchResultsHref(config);
  const showDealers =
    config.pageType !== SEO_PAGE_TYPES.DEALER_CITY &&
    Boolean(config.city && config.citySlug);
  const isDealerCity = config.pageType === SEO_PAGE_TYPES.DEALER_CITY;

  return (
    <div className="seo-landing">
      <header className="seo-landing__header">
        <div className="seo-landing__brand">
          <Link to="/v/automap">AutoMapa</Link>
        </div>
        <SeoBreadcrumbs items={breadcrumbs} />
        <h1>{config.h1}</h1>
        {config.introCopy ? <p className="seo-landing__intro">{config.introCopy}</p> : null}
        {metadata?.robots?.startsWith("noindex") ? (
          <p className="seo-landing__notice" role="status">
            Página con inventario limitado — exploramos opciones relacionadas abajo.
          </p>
        ) : null}
      </header>

      <SeoTrustStrip />

      <SeoInventoryModule
        config={config}
        listings={listings}
        featuredListings={featuredListings}
        total={inventoryTotal}
        loading={loading}
        error={inventoryError}
      />

      <SeoBuyerGuidance />

      {isDealerCity ? (
        <SeoDealerCityModule
          city={config.city}
          citySlug={config.citySlug}
          dealers={dealers}
          loading={dealersLoading}
        />
      ) : null}

      {showDealers ? <SeoDealerSection city={config.city} citySlug={config.citySlug} /> : null}

      <SeoFaqSection items={faqItems} />

      <SeoInternalLinks links={internalLinks} />

      <section className="seo-landing__ctas">
        <Link
          to={searchHref}
          className="seo-btn seo-btn--primary"
          onClick={() => trackSeoPageEvent(SEO_ANALYTICS_EVENTS.FILTER_CLICKED, { source: "footer_cta" })}
        >
          Buscar vehículos
        </Link>
        <Link
          to="/v/automap/comprar/quiz"
          className="seo-btn seo-btn--secondary"
          onClick={() => {
            updateAttributionContext({
              sourceComponent: "seo_quiz_cta",
              sourceAction: "quiz_start",
              eventName: "seo_quiz_cta",
              seoPageType: config.pageType,
              seoPageSlug: config.slug,
              pagePath: config.path,
            });
            trackSeoPageEvent(SEO_ANALYTICS_EVENTS.BUYER_QUIZ_CLICKED, { source: "footer_cta" });
          }}
        >
          Quiz de compra
        </Link>
        <Link
          to="/guias/checklist-compra-carro-usado"
          className="seo-btn seo-btn--ghost"
          onClick={() => {
            updateAttributionContext({
              sourceComponent: "seo_checklist_cta",
              sourceAction: "checklist_open",
              eventName: "seo_checklist_cta",
              seoPageType: config.pageType,
              seoPageSlug: config.slug,
              pagePath: config.path,
            });
            trackSeoPageEvent(SEO_ANALYTICS_EVENTS.CHECKLIST_CLICKED, { source: "footer_cta" });
          }}
        >
          Checklist
        </Link>
      </section>
    </div>
  );
}
